module.exports = __webpack_public_path__ + "img/18_r.0acbcf9f.jpg";